// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import {
  Spinner,
  Button,
  Warning
} from '../'

import { encodeBase64, decodeBase64 } from '../../utils'

import { CONTENTTYPE_CONSOLIDATION } from '../../constants'

const QUERY_FILERELATIONS = gql`
  query($contentType: ID!, $consolidation: UUID!) {
    filerelations(contentType_Id: $contentType, objectId: $consolidation, orderBy: "-created_at", first: 1) {
      edges {
        node {
          id
          file {
            id
            asset
          }
        }
      }
    }
  }
`


export class StatementFile extends React.PureComponent {
  static propTypes = {
    consolidation: PropTypes.string,
    file: PropTypes.string,
    viewFile: PropTypes.func.isRequired
  }

  render() {
    if (this.props.file) {
      return (
        <Button type='reset' onClick={e => {
          e.stopPropagation()
          this.props.viewFile(this.props.file)
        }}>
          View file
        </Button>
      )
    } else {
      return (
        <Query
          query={QUERY_FILERELATIONS}
          variables={{
            contentType: encodeBase64(CONTENTTYPE_CONSOLIDATION, "ContentTypeNode"),
            consolidation: decodeBase64(this.props.consolidation)
          }}>
          {({ loading, error, data }) => {
            if (loading) {
              return <Spinner className='slds-is-relative' size='small' />
            }
            if (error) {
              return (
                <Warning inline={true} iconSize='x-small'>
                  Loading file failed.
                </Warning>
              )
            }
            if (data.filerelations.edges.length === 0) {
              return 'No statement linked'
            } else {
              return (
                <Button type='reset' onClick={e => {
                  e.stopPropagation()
                  this.props.viewFile(data.filerelations.edges[0].node.file.id)
                }}>
                  View file
                </Button>
              )
            }
          }}
        </Query>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/credit-application-credit-report/StatementFile.js